import { z } from 'zod/v4';

const TARGET_TYPE = ['channel', 'popup', 'sdk', 'server'] as const;
const EVENT_TYPE = ['request', 'response', 'notification'] as const;

const INFINEX_MESSAGE_NAMESPACES = [
  'handshake',
  'authentication',
  'eip1193',
  'solana-wallet',
  'heartbeat',
  'infinex-ui',
  'session-change',
  'stored-data',
  'infinex-operation',
  'server-response',
  'popup-info',
  'test',
] as const;

// Subset of InfinexMessageNamespace for wallet requests.
const PROVIDER_REQUEST_NAMESPACES = ['eip1193', 'solana-wallet'] as const;
export const PASSTHROUGH_NAMESPACES = ['eip1193', 'solana-wallet'] as const;

export const messageNamespaceSchema = z.enum(INFINEX_MESSAGE_NAMESPACES);
export const providerRequestNamespaceSchema = z.enum(
  PROVIDER_REQUEST_NAMESPACES
);
export const targetTypeSchema = z.enum(TARGET_TYPE);
export const eventTypeSchema = z.enum(EVENT_TYPE);

export type InfinexEventType = z.infer<typeof eventTypeSchema>;
export type InfinexMessageNamespace = z.infer<typeof messageNamespaceSchema>;
export type ProviderRequestNamespace = z.infer<
  typeof providerRequestNamespaceSchema
>;
export type TargetType = z.infer<typeof targetTypeSchema>;
export type PassthroughNamespace = (typeof PASSTHROUGH_NAMESPACES)[number];
